import React, { PureComponent } from 'react'
import { getObjValue } from '@hlj/hlj-utils'
import styles from './style.module.less'
import Upload from '../Upload'
import SlideModal from '../SlideModal'
import ClipModal from '../ClipModal'
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons'
import { message, Checkbox } from 'hljd'
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from 'react-sortable-hoc'
import { getCropData, getImageViewLink } from '@util'

const SortableItem = SortableElement(({ children }) => children)
const SortableList = SortableContainer(({ children }) => (
  <div className={styles.sort_container}>{children}</div>
))
export default class extends PureComponent {
  static defaultProps = {
    imgList: [],
    showUpload: true,
    multiple: false,
    showRemove: true,
    showPreview: true,
    keyField: 'url',
    //设置target='_blank'时点击预览会跳转到新页面显示点击的图片且onPreview失效
    target: '_self',
    checkable: false,
    clipabled: false, //是否可在预览图中剪裁target='_self'才有效
    sortabled: false, //能否拖动排序
    title: null, //每个item的额外的信息
    description: null, // 上传组件的描述
    renderExtra: undefined,
    autoCut: false, // 加裁剪参数，不出现裁剪框
    autoClip: false // 上传后自动裁剪
  }
  state = {
    prew: false,
    initialSlide: 0,
    uploaded: false,
    link: '',
    info: null,
    file: null
  }
  preview = (initialSlide, item) => () => {
    if (this.props.onPreview) {
      this.props.onPreview(item, initialSlide)
    } else {
      this.setState({ prew: !this.state.prew, initialSlide })
    }
  }
  deleteItem = (index, item) => () => {
    this.props.onRemove && this.props.onRemove(index, item)
  }
  uploadOk = (file, link, info) => {
    const { autoCut, autoClip, aspect, validator } = this.props
    if (autoClip) {
      this.setState({
        uploaded: true,
        link,
        info,
        file
      })
      return
    }
    if (validator && !validator(file, link, info)) {
      return
    }
    if (autoCut) {
      const cropData = getCropData(link, info, aspect)
      info.crop = cropData.crop
      link = cropData.clipUrl
    }
    this.props.onOk && this.props.onOk(link, info, file)
  }
  autoCliped = clipInfo => {
    const {
      clipUrl,
      crop,
      pixel: { height, width }
    } = clipInfo
    const { info, file } = this.state
    const { validator } = this.props
    info.crop = crop
    info.height = height
    info.width = width
    if (validator && !validator(file, clipUrl, info)) {
      return
    }
    this.setState({
      uploaded: false
    })
    this.props.onOk && this.props.onOk(clipUrl, info, file)
  }
  cancelCliped = () => {
    const { link, info, file } = this.state
    const { validator } = this.props
    if (info.crop) {
      this.setState({
        uploaded: false
      })
      return
    }
    if (validator && !validator(file, link, info)) {
      return
    }
    this.setState({
      uploaded: false
    })
    this.props.onOk && this.props.onOk(link, info, file)
  }
  uploadError = (up, err, errTip) => {
    this.props.onError && this.props.onError(up, err, errTip)
  }
  beforeUp = (files, up, progressHandler) => {
    const { max, imgList } = this.props
    const nowListLen = imgList.length
    let flag = false
    files.forEach((file, i) => {
      if (max && nowListLen + i > max - 1) {
        flag = true
        up.removeFile(file.id)
        progressHandler(false)
      }
    })
    if (flag) {
      message.warning(`最多上传${max}张图片`)
    }
  }
  doCheck = (item, index) => e => {
    this.props.onCheck && this.props.onCheck(e.target.checked, item, index)
  }

  sortEnd = ({ oldIndex, newIndex }) => {
    if (this.props.onSort) {
      this.props.onSort(arrayMove(this.props.imgList, oldIndex, newIndex))
    }
  }

  render() {
    const {
      imgList,
      style,
      itemStyle = {},
      showUpload,
      multiple,
      checkable,
      preSuffix,
      showPreview,
      autoSuffix,
      showRemove,
      keyField,
      target,
      sortabled,
      clipabled,
      onCliped,
      clipConfig,
      aspect,
      title,
      filters,
      description,
      max_file_size = '100mb',
      renderExtra,
      uploadConfig = {},
      max,
      uploadedImgStyle = {},
      autoClip
    } = this.props
    const { initialSlide, prew, uploaded, link } = this.state
    return (
      <div className={styles.container} style={style}>
        <SortableList
          onSortEnd={this.sortEnd}
          axis="xy"
          hideSortableGhost={false}
        >
          {imgList.map((item, index) => {
            let url
            let checked = false
            if (typeof item === 'string') {
              url = item
            } else {
              item = item || {}
              url = getObjValue(item, keyField)
              checked = item.checked
            }
            url = url || ''
            const { width } = itemStyle
            const fixWidth = !isNaN(width) ? Math.round(width) : 180
            // const src =
            //   url.indexOf('imageMogr2/crop') === -1
            //     ? handleImgSuffix(
            //         url,
            //         `imageView2/1/w/${fixWidth}/h/${fixHeight}`
            //       )
            //     : url

            const src = getImageViewLink(url, fixWidth)
            // const src = getImageAutoOrientLink(url)
            const _title =
              typeof title === 'function' ? title(item, index) : title
            return (
              <SortableItem disabled={!sortabled} key={index} index={index}>
                <div
                  className={styles.item}
                  style={{ ...itemStyle, ...uploadedImgStyle }}
                >
                  {checkable && (
                    <span className={styles.select}>
                      <Checkbox
                        checked={checked}
                        onChange={this.doCheck(item, index)}
                      />
                    </span>
                  )}
                  <div className={styles.action}>
                    {showPreview && (
                      <span
                        onClick={
                          target === '_blank'
                            ? undefined
                            : this.preview(index, item)
                        }
                      >
                        {target === '_blank' ? (
                          <a
                            style={{ color: '#fff' }}
                            rel="noopener noreferrer"
                            target="_blank"
                            href={url}
                          >
                            <EyeOutlined />
                          </a>
                        ) : (
                          <EyeOutlined />
                        )}
                      </span>
                    )}
                    {showRemove && (
                      <span onClick={this.deleteItem(index, item)}>
                        <DeleteOutlined />
                      </span>
                    )}
                  </div>
                  <img src={src} alt="img" />
                  {_title && <div className={styles.title}>{_title}</div>}
                  {typeof renderExtra === 'function'
                    ? renderExtra(item, index)
                    : null}
                </div>
              </SortableItem>
            )
          })}
          {!(max && imgList.length >= max) && (
            <div
              className={styles.item}
              style={{ ...itemStyle, display: showUpload ? 'block' : 'none' }}
            >
              <Upload
                multiple={autoClip ? false : multiple}
                onAdded={this.beforeUp}
                onOk={this.uploadOk}
                onError={this.uploadError}
                width="100%"
                height="100%"
                max_file_size={max_file_size}
                filters={filters}
                description={
                  <div className={styles.description}>{description || ''}</div>
                }
                {...uploadConfig}
              />
            </div>
          )}
        </SortableList>
        {autoClip &&
          uploaded && (
            <ClipModal
              aspect={aspect}
              clipConfig={clipConfig}
              onCliped={this.autoCliped}
              visible={uploaded}
              img={link}
              index={initialSlide}
              onCancel={this.cancelCliped}
            />
          )}
        {prew &&
          !clipabled && (
            <SlideModal
              aspect={aspect}
              autoSuffix={autoSuffix}
              suffix={preSuffix}
              visible={prew}
              keyField={keyField}
              imgList={imgList}
              initialSlide={initialSlide}
              onCancel={this.preview(0)}
            />
          )}
        {prew &&
          clipabled && (
            <ClipModal
              aspect={aspect}
              clipConfig={clipConfig}
              onCliped={onCliped}
              visible={prew}
              keyField={keyField}
              img={imgList[initialSlide]}
              index={initialSlide}
              onCancel={this.preview(0)}
            />
          )}
      </div>
    )
  }
}
